namespace appn.views.dataSources.rows {

    class InitArgs {
        dataSourceId: string = emptyString;
        providerId: number = 0;
        maxEditableColumnsAllowed: number = 50;
        maxEditableRowsAllowed: number = 100;
        dataColCount: number = 0;
        placeholderImageUrl: string = emptyString;
        appliedFilters: Array<AppliedFilter> = [];
        formula: string = emptyString;
        sortOrder: string = emptyString;
        errorMessage: string = emptyString;
        connectorType: string = emptyString; 
        canUseFilterOptions: boolean = false;
        canSave: boolean = false;
        headers: Array<Header> = [];
        referringHeaders: { [key: string]: Array<string> } = {};
        datasourceType: DataSourceType = DataSourceType.UserDefined;
        dataSourceRowsExport: string = emptyString; 
        dataSourcesItemsImageDelete: string = emptyString; 
        dataSourcesItemsImageDeleteBulk: string = emptyString; 
        dataSourcesGetIconUrl: string = emptyString; 
        isShowImport: boolean = false;
    }

    const _headerTypes: { [key: string]: string } = {};
    const _referringDatasourceColumns: { [key: string]: ReferringDatasourceColumn } = {};
    let _filterIdsInUse: number[] = [];
    let _initArgs: InitArgs;
    let _previousDataType = appn.emptyString;
    let _filterCount = 1;
    let _filterOptionTemplate: JQuery<HTMLElement>;

    let _datatable: any = null;

    export function init(args: InitArgs): void {
        _initArgs = args;

        bindImportButton();

        bindAddRow();

        if ($('table#dtItems').length)
            createDataTable();

        (appn as any).oTableSlItems = null;

        if ($('table#slItems').length && $('table#slItems').hasClass('dataTable'))
            initslItemsDT();
        else
            select.init({ selector: '#slItems select.datatype', omitWidth: true });

        if ($('#slItems .select-icons').length)
            select.init({
                selector: '#slItems .select-icons',
                isIconSelect: true
            });
        
        bindFileUploadControls();

        $('.colSettingsDialog .displayRule').each(function() {
            bindDisplayConditions($(this));
        });

        // Prepend the show button
        (appn as any).sideFilterAndContent.appendShowButton($('#dsTableTools'), 'mr-2');
        (appn as any).sideFilterAndContent.appendShowButton($('#dtItems_filter'), 'mr-2');

        // Filter Controls
        _filterIdsInUse.push(1);
        _filterOptionTemplate = $('#container-filterOptionTemplate #filterOptionBox_id_').clone();

        if (_initArgs.headers) {
            const headersArray = _initArgs.headers;

            for (let i = 0; i < headersArray.length; i++) {
                const header = headersArray[i];
                // Set the header types
                _headerTypes[header.name] = header.dataType;

                // Set columns which refer to another datasource
                if (header.refId && _initArgs.referringHeaders.keys?.length > 0 && _initArgs.referringHeaders[header.name].length > 0) {
                    // Get the list of columns for the datasource
                    const columns: string[] = _initArgs.referringHeaders[header.name];

                    // Make string safe
                    for (let i = 0; i < columns.length; i++)
                        columns[i] = columns[i].replace(`'`, appn.emptyString).replace(`"`, appn.emptyString);


                    // Create an object to hold the data for each column
                    const referringDatasourceColumn: ReferringDatasourceColumn = { refId: header.refId, columns: columns };

                    // Add all the columns into one object
                    _referringDatasourceColumns[header.name] = referringDatasourceColumn;

                    // Set the header type of this header to "DataSource" so that it can be identified. "$(document).on('change', '.filterHeader', function (e) {"
                    _headerTypes[header.name] = 'DataSource';
                }
            }
        }

        for (let i = 0; i < _initArgs.appliedFilters.length; i++) {

            if (_filterCount !== 1)
                addFilter();

            $(`#filterHeader${_filterCount}`).val(_initArgs.appliedFilters[i].headerName);
            $(`#filterFunction${_filterCount}`).val(_initArgs.appliedFilters[i].filterType);
            $(`#filterBy${_filterCount}`).val(_initArgs.appliedFilters[i].dataValue);

            if (i < _initArgs.appliedFilters.length - 1)
                _filterCount++;
        }

        addEvents();
        addDateTimePickerOnInit();

        if (_initArgs.isShowImport)
            $('.uploadDataSourceBtn').trigger('click');
        
    }

    function createDataTable() {
        _datatable = appn.dataTable.create('#dtItems', {
            scrollX: '100%',
            sInfoFiltered: function() {
                bindFileUploadControls();
            },
            bSort: false,
            ordering: false,
            sAjaxSource: '../RowsDataTable',
            contentType: 'application/json; charset=utf-8',
            fnServerData: function(data: any) {
                // This data needs to be in this order, even if no data exists, then just a blank string must be submitted.
                // The controller method expects the data in this order.
                data.push({ name: 'sCustom_0', value: _initArgs.dataSourceId }, // Send current List id
                    { name: 'sCustom_1', value: $('#SelectedUserItem option:selected').val() }, // Sends the current selected user item
                    { name: 'sCustom_2', value: JSON.stringify(_initArgs.appliedFilters) }, // Filters from the "Filter Options" modal
                    { name: 'sCustom_3', value: _initArgs.formula }, // A formula to filter by from the right side menu
                    { name: 'sCustom_4', value: _initArgs.sortOrder }); // The sort order, comma and the column to sort on e.g. Asc,Price
            },
            fnInitComplete: function() {
                bindFileUploadControls();
                appn.dataTable.addSearchPlaceholder(T(`Filter results where this Data Source's <b>Rows or Columns</b> contain a keyword typed in here.`));
            },
            fnDrawCallback: function() {
                // retrieve total then update
                const total = _datatable.fnSettings().fnRecordsTotal();

                $('#rowsCountDisplay').html(total);
                if (_initArgs.errorMessage !== appn.emptyString)
                    $('.dataTables_noData').append(`<br><span class="lead text-gray">${_initArgs.errorMessage}</span>`);

                if (_initArgs.connectorType === 'HostedGet')
                    $('.ds-row-count').html(total);

                appn.select.init({ selector: 'thead:first .datatype' });
            }
        });

        setTimeout(function() {
            appn.select.init({
                selector: 'thead:first .datatype'
            });
        }, 500);
    }

    function addEvents() {
        $('#exportRows').off().on('click', function(event) {
            event.preventDefault();

            $('#dialog-exportDataSource').modal('show');
        });

        $('#exportRowsDialogButton').off().on('click', function(event) {
            event.preventDefault();

            appn.ajax.get({
                url: _initArgs.dataSourceRowsExport,
                data: {
                    id: _initArgs.dataSourceId,
                    providerId: _initArgs.providerId,
                    isProtectData: $('#AnonymizePersonalData').is(':checked')
                },
                done: function() {
                    appn.notifications.updateNotificationTotal();
                    $('#dialog-exportDataSource').modal('hide');
                    ui.showExportConfirmation('Data Source');
                }
            });
        });

        $('.appn-dropdown-btn .btn-dropdown-item').off().on('click', function(event) {
            event.preventDefault();
            const currentColCount = $('#slItems thead tr th.dataCol').length;
            const maxRestriction = _initArgs.maxEditableColumnsAllowed - currentColCount;

            if (currentColCount >= _initArgs.maxEditableColumnsAllowed) {
                appn.dialog.alert({
                    title: T('Max Columns Reached'),
                    message: T('You cannot add/edit more than {0} columns here since this will force you to use the API for future edits on this data source. This is due to browser performance issues when loading large tables.<br><br>You can try:<ul><li>Removing columns you dont need</li><li>Using the API to add more columns beyond the limit of {0} on this page</li><li>Import a data source from Excel with as many columns as you like</li></ul>', _initArgs.maxEditableColumnsAllowed),
                    modalColor: 'modal-danger',
                    buttons: {
                        ok: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    autoHeaderIcon: false
                });
                return;
            }

            // Get number to add and submit
            const numberOfNewCols = $(this).data('value');
            $('#NewColumnsToAdd').val(numberOfNewCols);
            $('form#appnForm').submit();
        });

        $(document).on('click', '.down_button', function() {
            const rowToMove = $(this).parents('#slItems tbody tr:first');
            const next = rowToMove.next('#slItems tbody tr');
            if (next.length === 1) {
                next.after(rowToMove);
                renameRows();
            }
        });

        $(document).on('click', '.up_button', function() {
            const rowToMove = $(this).parents('#slItems tbody tr:first');
            const prev = rowToMove.prev('#slItems tbody tr');
            if (prev.length === 1) {
                prev.before(rowToMove);
                renameRows();
            }
        });

        $(document).on('click', '.delete_button', function() {

            const $theRowToRemove = $(this).parents('tr');

            let deleteRowMessage = T('Are you sure you want to delete this row?');
            if ($theRowToRemove.hasClass('row-dummy'))
                deleteRowMessage = T(`Kindly note that this is a dummy row. It is used to allow the App to update/create/delete rows from this data source.  Deleting this row will disallow row modifications from the App.<br><br>Don't worry, you will be able to re-allow modifications if you wish.<br><br>Hit <b>OK</b> to delete this row.`);

            appn.dialog.confirm({
                modalColor: 'modal-danger',
                title: T('Confirm Row Delete'),
                message: deleteRowMessage,
                isDeleteAction: true,
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                callback: function(result: any) {
                    if (result) {

                        // We need to go through all of the columns and see if there is any image columns that will
                        // need files cleaning up on server
                        const bulkImagesToDelete: Array<string> = [];
                        $theRowToRemove.find('.imageFileLocation').each(function(index, row) {
                            bulkImagesToDelete.push($(this).val() as string);
                        });

                        if (bulkImagesToDelete.length !== 0)
                            deleteImageFromServerBulk(bulkImagesToDelete);

                        // Remove the row
                        $theRowToRemove.remove();
                        renameRows();

                        // Show the no rows message
                        const $tableBodyHtml = $('table.table tbody');
                        if ($tableBodyHtml.html().trim().length === 0) {
                            const zeroRowsHtml = `<tr class='odd zero-rowsmessage'><td valign='top' colspan='14' class='dataTables_empty text-center'><h2 class='dataTables_noData text-center mb-30'><span class='lead text-gray'>${T(`This Data Source currently has 0 rows. <br>Try <a href='#' class='addValue'>adding a row</a>. You can also <a href='#' class='uploadDataSourceBtn'>import a data source</a> from Excel`)}</span></h2 ></td ></tr > `;
                            $tableBodyHtml.append(zeroRowsHtml);
                            bindAddRow();
                            bindImportButton();
                        }
                    }
                }
            });
        });

        $(document).on('click', '.delete_button_conditional_display_rule', function() {

            const $theRowToRemove = $(this).closest('.displayRule');

            const deleteRowMessage = T('Are you sure you want to delete this row?');

            appn.dialog.confirm({
                modalColor: 'modal-danger',
                title: T('Confirm Row Delete'),
                message: deleteRowMessage,
                isDeleteAction: true,
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                callback: function(result: any) {
                    if (result) {
                        $theRowToRemove.remove();
                        renameRows();
                    }
                }
            });
        });

        $('#SelectedUserItem').change(function(event) {
            event.preventDefault();
            _datatable.fnDraw();
        });

        $(document).on('click', '.dataCol .select2', function() {
            _previousDataType = $(this).closest('.form-group').find('select.datatype').val() as string;
        });

        $(document).on('change', '.datatype', function() {
            saveAndSubmitDataSource();          // always force reload to get data type header text correct, plus need to change if to/from image columns etc
        });

        $('.colSettingsBtn').off().on('click', function(event) {
            event.preventDefault();
            const colHref = $(this).attr('href') as string;
            $(colHref).modal('show');

            $(colHref).find('.modal-body .card-no-header').show();

            if (_initArgs.datasourceType === DataSourceType.App) {
                $(colHref).find('.modal-body .card-no-header').hide();
                $(colHref).find('.modal-header div:not(.modal-title-container)').remove();

                const saveBtn = `<div class="modal-toolbar pull-right">
                                     <button name="submitType" value="Save" class="btn btn-success">
                                         <span>Save</span>&nbsp;<i class="fa fa-save"></i>
                                     </button>
                                 </div>`;

                $(colHref).find('.modal-header').append(saveBtn);
            }

            select.init({
                selector: 'select[id$="__Style_Size"]:not(#displayRuleTemplate select)',
                omitWidth: true
            });
        });

        $(document).on('click', '.colDeleteBtn', function(event) {
            event.preventDefault();

            const headerIndex = $(this).data('headerindex');
            const headerName = $(this).data('headername');
            deleteDataCol(event, headerIndex, headerName)
        });

        $('a.addDisplayRule').each(function() {
            const $addLink = $(this);
            $addLink.off().on('click', function() {
                const headerIdx = $(this).data('headeridx');
                const newRowIdx = (new Date()).getTime();

                select.destroy('#displayRuleTemplate select');

                let templateHtml = $('#displayRuleTemplate').html();
                templateHtml = templateHtml.replace(/Headers\[0\]/g, 'Headers[' + headerIdx + ']')
                    .replace(/Headers_0__/g, 'Headers_' + headerIdx + '__')
                    .replace(/DisplayRules\[0\]/g, 'DisplayRules[' + newRowIdx + ']')
                    .replace(/DisplayRules_0__/g, 'DisplayRules_' + newRowIdx + '__');

                const $displayRulesContainer = $(this).closest('.colSettingsDialog').find('.displayRulesContainer');
                const $newRule = $(templateHtml);
                $newRule.filter('.displayRuleIndexer').val(newRowIdx);
                bindDisplayConditions($newRule);
                $displayRulesContainer.append($newRule);

                select.init({
                    selector: 'select[id$="__Style_Size"]:not(#displayRuleTemplate select)',
                    omitWidth: true
                });
            });
        });

        $('#applyFilters').click(function(event) {
            applyFiltersAndOptions(false);

            // Close the modal
            $('#filterOptionsModal').modal('show');
        });


        $('.btnFilterOptions').click(function(event) {
            if (_initArgs.canUseFilterOptions)
                $('#filterOptionsModal').modal('show');
            else
                $('#showModalOnClick').modal('show');
        });

        $('#filterOptionsModal').on('shown.bs.modal', function() {
            select.init({ selector: '#filterOptions select[id^=filter]' });
        });

        $('#applyOptions').click(function(event) {
            applyFiltersAndOptions(false);
        });

        $('#clearFilters').on('click', function(event) {
            applyFiltersAndOptions(true);
        });

        $('.btnEnableModifyFromApp').off().on('click', function(e) {
            e.preventDefault();

            const _that = $(this);
            appn.dialog.confirm({
                modalColor: 'modal-info',
                title: T('Allow Modify From App'),
                message: T('Click <b>OK</b> to allow this data sources rows to be updated/created/deleted by a Form Screen in the App.'),
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                callback: function(result: any) {
                    if (result) {
                        addNewRow(true);
                        $(_that).hide();
                    }
                }
            });
        });

        $('#addFilter').on('click', function() {
            addFilter(true);
        });

        // Slightly different syntax for .click as the elements are created dynamically.
        $(document.body).on('click', '.deleteFilterOption', function(e) {

            const filterToDelete = ($(this).attr('id') || appn.emptyString).replace('deleteFilterOption', appn.emptyString);

            // Don't allow the last filter to be removed, instead reset its values.
            if (_filterCount <= 1) {
                $('#filterHeader' + filterToDelete).prop('selectedIndex', 0).change();
                $('#filterFunction' + filterToDelete).prop('selectedIndex', 0).change();
                $('#filterBy' + filterToDelete).val(appn.emptyString);
                addDateTimePickerOnInit(filterToDelete);
                select.init({ selector: '#filterOptions select[id^=filter]' });
            } else {

                $('#filterOptionBox' + filterToDelete).remove();

                // Remove the ID from filterIdsInUse
                const index = _filterIdsInUse.indexOf(parseInt(filterToDelete, undefined));
                _filterIdsInUse.splice(index, 1);

                _filterCount--;

                for (let i = 0; i < _filterCount; i++) {
                    let newTemplate = $('#container-filterOptionTemplate').html();
                    newTemplate = newTemplate.replace(/_id_/g, i + 1 as unknown as string);
                    $('#filterOptionBox' + _filterIdsInUse[i]).replaceWith(newTemplate);
                }  
                _filterIdsInUse = Array.from({ length: _filterCount }, (_, i) => i + 1);
                select.init({ selector: '#filterOptions select[id^=filter]' });
            }
        });

        // Change the input type for filtering for special columns types
        $(document).on('change', '.filterHeader', function(e) {

            const id = ($(this).attr('id') || appn.emptyString).replace('filterHeader', appn.emptyString);
            const header = $(this).find(':selected').val() as string;
            const headerType: string = _headerTypes[header];

            switch (headerType) {
                case 'DateTime':
                    if (!$('#filterBy' + id).parent().hasClass('datetimepicker'))
                        $('#filterBy' + id).each(function() {
                            $(`<div class="input-group date datetimepicker">
                                <input class="form-control" id="filterBy${id}" name="filterBy${id}" type="text" value="">
                                <div class="input-group-append input-group-addon">
                                    <button class="input-group-text btn btn-secondary" type="button"><i class="fa fa-calendar fa-xs"></i></button>
                                </div>
                               </div>`)
                                .insertBefore(this);
                        }).remove();

                    // Add the function to display the popup calendar.
                    // The calendar only displays on the second click,
                    // so simulate one click to make it instant for users.
                    $('#filterBy' + id).on('click', function() {
                        appn.ui.dateTimePicker(($(this) as any), undefined, 'YYYY-MM-DD HH:mm:ss');
                    }).trigger('click');
                    break;
                case 'DataSource':
                    // If the current item is a date picker
                    if ($('#filterBy' + id).parent().hasClass('datetimepicker')) {
                        $('#filterBy' + id).parent().each(function() {
                            $('<select class="form-control-sm form-control" id="filterBy' + id + '" name="filterBy' + id + '"></select>')
                                .insertBefore(this);
                        }).remove();

                        // Add all the options for this column
                        const columns = (_referringDatasourceColumns[header] as any).columns;
                        for (let i = 0; i < columns.length; i++)
                            $('#filterBy' + id).append($('<option>', {
                                value: columns[i],
                                text: columns[i]
                            }));
                    } else {
                        $('#filterBy' + id).each(function() {
                            $('<select class="form-control-sm form-control" id="filterBy' + id + '" name="filterBy' + id + '"></select>')
                                .insertBefore(this);
                        }).remove();

                        // Add all the options for this column
                        const columns = (_referringDatasourceColumns[header] as any).columns;
                        for (let i = 0; i < columns.length; i++)
                            $('#filterBy' + id).append($('<option>', {
                                value: columns[i],
                                text: columns[i]
                            }));
                    }
                    break;
                default:
                    // If the current item is a date picker
                    if ($('#filterBy' + id).parent().hasClass('datetimepicker')) {
                        $('#filterBy' + id).parent().each(function() {
                            $(`<div class="input-group date datetimepicker">
                                <input class="form-control" id="filterBy${id}" name="filterBy${id}" type="text" value="">
                                <div class="input-group-append input-group-addon">
                                    <button class="input-group-text btn btn-secondary" type="button"><i class="fa fa-calendar fa-xs"></i></button>
                                </div>
                               </div>`)
                                .insertBefore(this);
                        }).remove();

                        appn.ui.dateTimePicker($(`#filterBy${id}`).parent(), undefined, 'YYYY-MM-DD HH:mm:ss');
                    }
                    else
                        $('#filterBy' + id).each(function() {
                            $('<input class="form-control-sm form-control" id="filterBy' + id + '" name="filterBy' + id + '" type="text">')
                                .insertBefore(this);
                        }).remove();
                    break;
            }
        });
    }

    function addFilter(incrementFilterCount?: boolean) {
        if (incrementFilterCount)
            _filterCount++;

        _filterIdsInUse.push(_filterCount);

        // Destroy the old select2 elements to clone a fresh template
        select.destroy('#filterOptions select[id^=filter]');
       
        // Rename ID's and then append the template
        // NOTE: Chain .attr when changing the ID, as the original doesn't exist after the ID is changed.
        let newTemplate = $('#container-filterOptionTemplate').html();
        newTemplate = newTemplate.replace(/_id_/g, _filterCount as unknown as string).replace('select2-noinit', emptyString);
        $('#filterOptions').append(newTemplate);
        addDateTimePickerOnInit(_filterCount.toString());

        select.init({ selector: '#filterOptions select[id^=filter]' });
    }

    function initslItemsDT() {
        (appn as any).oTableSlItems = appn.dataTable.create('#slItems', {
            sDom: appn.dataTable.genSDom(0, 0, 0),
            scrollX: '100%',
            paging: false,
            ordering: false,
            info: false,
            searching: false,
            bSort: false,
            fnInitComplete: function(): any {
                $('table#slItems').addClass('datatable_initialized');
                setTimeout(function() {
                    select.init({ selector: '.dataTables_scrollHeadInner select.datatype', omitWidth: true });
                    select.init({
                        selector: '.select-icons:not(#iconControlTemplate .select-icons)',
                        isIconSelect: true
                    });
                }, 250);
            }
        });
    }

    function saveAndSubmitDataSource() {

        appn.dialog.showLoading();

        $('<input />').attr('type', 'hidden')
            .attr('name', 'submitType')
            .attr('value', 'Save')
            .appendTo('#appnForm');

        $('#appnForm').submit();
    }

    function renameRows() {
        // rename all remaining rows to keep continuous index
        let idx = 0;
        $('#slItems tbody tr').each(function(index, row) {
            let colIdx = 0;
            $(this).find('td.dataCol').each(function(index, col) {
                $(this).find('input,textarea,select')
                    .attr('name', 'Items[' + idx + '].Data[' + colIdx + ']')
                    .attr('id', 'Items_' + idx + '__Data_' + colIdx);
                colIdx++;
            });
            idx++;
        });
    }

    function renameDataCols() {
        // Rename remaining dataCols to keep continuous index
        let headIdx = 0;
        $('#slItems thead tr th.dataCol').each(function(index, row) {
            $(this).removeClass();
            $(this).addClass('dataCol dataCol' + headIdx);

            const localIdx = headIdx;
            $(this).find('input[id$="__Name"]')
                .attr('name', 'DataSource.Headers[' + headIdx + '].Name')
                .attr('id', 'DataSource_Headers_' + headIdx + '__Name');
            $(this).find('input[id$="__DisplayOrder"]')
                .attr('name', 'DataSource.Headers[' + headIdx + '].DisplayOrder')
                .attr('id', 'DataSource_Headers_' + headIdx + '__DisplayOrder');
            $(this).find('select')
                .attr('name', 'DataSource.Headers[' + headIdx + '].DataType')
                .attr('id', 'DataSource_Headers_' + headIdx + '__DataType');

            // Reindex setings button refs
            $(this).find('.colSettingsBtn')
                .attr('href', '#colSettingsDialog' + headIdx)
                .off().on('click', function(event) {
                    event.preventDefault();
                    const colHref = $(this).attr('href') as string;
                    $(colHref).modal('show');
                });

            headIdx++;
        });

        headIdx = 0;
        $('#slItems tbody tr td.dataCol').each(function(index, row) {
            $(this).removeClass();
            $(this).addClass('dataCol dataCol' + headIdx);

            const localIdx = headIdx;
            $(this).find('input[id$="__Name"]')
                .attr('name', 'DataSource.Headers[' + headIdx + '].Name')
                .attr('id', 'DataSource_Headers_' + headIdx + '__Name');
            $(this).find('input[id$="__DisplayOrder"]')
                .attr('name', 'DataSource.Headers[' + headIdx + '].DisplayOrder')
                .attr('id', 'DataSource_Headers_' + headIdx + '__DisplayOrder');
            $(this).find('select')
                .attr('name', 'DataSource.Headers[' + headIdx + '].DataType')
                .attr('id', 'DataSource_Headers_' + headIdx + '__DataType');

            headIdx++;
        });

        let rowIdx = 0;
        $('#slItems tbody tr').each(function(index, row) {
            let colIdx = 0;
            $(this).find('td.dataCol').each(function(index, row) {
                $(this).removeClass();
                $(this).addClass('dataCol dataCol' + colIdx);

                $(this).find('input,textarea,select')
                    .attr('name', 'Items[' + rowIdx + '].Data[' + colIdx + ']')
                    .attr('id', 'Items_' + rowIdx + '__Data_' + colIdx);

                colIdx++;
            });
            rowIdx++;
        });
    }

    function renameColSettingsDialogs(currentIndex: number, colCount: number) {
        for (let i = currentIndex; i < colCount; i++) {
            const orgIdx = i + 1;
            const colSettingsDialog = $('#colSettingsDialog' + orgIdx);

            // If it exists then we need to update the indexes
            if (colSettingsDialog) {
                const elementsToUpdate = colSettingsDialog.find('input,select,for[id^="DataSource_Headers_' + orgIdx + '"]');

                elementsToUpdate.each(function(index, row) {
                    const currentId = $(this).prop('id');
                    const currentName = $(this).prop('name');
                    if (currentId) {
                        const newId = currentId.replace('DataSource_Headers_' + orgIdx, 'DataSource_Headers_' + i);
                        $(this).prop('id', newId);
                    }

                    if (currentName) {
                        const newName = currentName.replace('DataSource.Headers[' + orgIdx, 'DataSource.Headers[' + i);
                        $(this).prop('name', newName);
                    }
                });
            }

            // Update this id to its new dialog id
            colSettingsDialog.prop('id', 'colSettingsDialog' + i);
        }
    }

    function deleteDataCol(event: JQuery.ClickEvent, colIdx: number, colName: string) {
        event.preventDefault();

        appn.dialog.confirm({
            modalColor: 'modal-danger',
            title: T('Confirm Column Delete'),
            message: T('Column {0} is about to be permanently deleted.<br>Hit the OK button to proceed.', colName),
            buttons: {
                confirm: {
                    label: '<span>' + T('OK') + '</span>',
                    className: 'btn-success'
                }
            },
            isDeleteAction: true,
            callback: function(result: any) {
                if (result)
                    if (_initArgs.dataColCount > 2) {
                        // We need to go through all of the columns and see if there is any image columns that will
                        // need files cleaning up on server
                        const bulkImagesToDelete: Array<string> = [];
                        $('.dataCol' + colIdx).find('.imageFileLocation').each(function(index, row) {
                            bulkImagesToDelete.push($(this).val() as string);
                        });
                        if (bulkImagesToDelete.length !== 0)
                            deleteImageFromServerBulk(bulkImagesToDelete);

                        const deletedIdx = colIdx;
                        $('.dataCol' + colIdx).remove();

                        // Must also remove the Dialog from the Dom
                        $('#colSettingsDialog' + colIdx).remove();

                        _initArgs.dataColCount--;

                        renameColSettingsDialogs(colIdx, _initArgs.dataColCount);
                        renameDataCols();

                        saveAndSubmitDataSource();
                    }
            }
        });
    }

    function deleteImageFromServer(imageUrl: string, afterDeleteCallback: Function) {
        appn.ajax.post({
            url: _initArgs.dataSourcesItemsImageDelete,
            dataType: 'json',
            data: {
                imageUrl: imageUrl
            },
            done: function() {
                appn.toast.notify(toast.Type.success, T(`Image deleted successfully. Don't forget to save your changes!`));
                if (afterDeleteCallback)
                    afterDeleteCallback();
            },
            fail: function() {
                appn.toast.notify(toast.Type.error, T('Failed to delete image!'));
                if (afterDeleteCallback)
                    afterDeleteCallback();
            }
        });
    }

    function deleteImageFromServerBulk(images: Array<string>) {

        const url = _initArgs.dataSourcesItemsImageDeleteBulk;

        appn.ajax.post({
            url: url,
            dataType: 'json',
            data: {
                imageUrls: images
            },
            done: function(e: number) {
                if (e !== 0)
                    appn.toast.notify(toast.Type.success, T(`{0} images deleted successfully. Don't forget to save your changes!`, e));
            },
            fail: function() {
                appn.toast.notify(toast.Type.error, T('Failed to delete some images!'));
            }
        });
    }

    function bindImportButton() {
        $('.uploadDataSourceBtn').off().on('click', function(event) {
            event.preventDefault();
            $('#dialog-uploadDataSource').modal('show');
        });
    }

    function addNewRow(isdummyRow: Boolean = false) {
        $('table.table tbody .zero-rowsmessage').remove();

        const currentRowCount = $('#slItems tbody tr').length;
        const maxRestriction = _initArgs.maxEditableRowsAllowed - currentRowCount;

        if (currentRowCount >= _initArgs.maxEditableRowsAllowed) {
            appn.dialog.alert({
                title: T('Max Editable Rows Reached'),
                message: T('We do not allow direct edits of Data Sources containing more than {0} rows. <br><br>Add/edit your data in a spreadsheet (e.g. MS Excel) and use the Import option to go beyond this {0} row limit./li></ul>', _initArgs.maxEditableRowsAllowed),
                modalColor: 'modal-danger',
                buttons: {
                    ok: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                autoHeaderIcon: false
            });
            return;
        }

        const $items = $('#slItems tbody');
        const idx = $items.children().length.toString();
        let reInitSelectForIconsRequired = false;

        let newRow = '<tr class="' + (isdummyRow ? 'row-dummy' : appn.emptyString) + '">';

        for (let i = 0; i < _initArgs.dataColCount; i++)
        {
            newRow += '<td class="dataCol dataCol' + i + '">';

            const currentDataType = $('#DataSource_Headers_' + i + '__DataType').val();
            if (currentDataType === 'Image' && !isdummyRow) {

                const $imageTemplate = $('#imageUploadTemplate').clone();
                const html = $imageTemplate.html().replace(/{ROWID}/g, idx).replace(/{COLID}/g, i.toString());

                let imageFileLocationTemplate = '<input class="imageFileLocation" id="Items_{ROWID}__Data_{COLID}_" name="Items[' + idx + '].Data[' + i + ']" type="hidden" value="">';
                imageFileLocationTemplate = imageFileLocationTemplate.replace(/{ROWID}/g, idx).replace(/{COLID}/g, i.toString());

                newRow += html;
                newRow += imageFileLocationTemplate;

                reInitSelectForIconsRequired = true;
            }
            else if (currentDataType === 'Icon' && !isdummyRow) {

                const $iconTemplate = $('#iconControlTemplate').clone();
                const html = $iconTemplate.html().replace(/{ROWID}/g, idx).replace(/{COLID}/g, i.toString());

                newRow += html;

                reInitSelectForIconsRequired = true;
            }
            else if (currentDataType === 'LongText' && !isdummyRow) {

                let longTextTemplate = `<textarea class="form-control-sm pt-8 form-control" cols="20" id="Items_{ROWID}__Data_{COLID}_" name="Items[{ROWID}].Data[{COLID}]" placeholder="${T("EMPTY")}" rows="7"></textarea>`;
                longTextTemplate = longTextTemplate.replace(/{ROWID}/g, idx).replace(/{COLID}/g, i.toString());

                newRow += longTextTemplate;
            }
            else {
                newRow += '<input type="text" name="Items[' + idx + '].Data[' + i + ']" id="Items_' + idx + '__Data_' + i + '" ' + (isdummyRow && i === 0 ? 'readonly=""' : appn.emptyString) + ` placeholder="${T("EMPTY")}" class="valid form-control-sm form-control" value="` + (isdummyRow && i === 0 ? '0' : appn.emptyString) + '">';
            }

            if (i === 0) {
                newRow +=
                    '<div class="rowTools">' +
                    `${elementBuilder.buildBtnMoveRow(true)}` +
                    `${elementBuilder.buildBtnMoveRow(false)}` +
                    `${elementBuilder.buildBtnRemoveRow('delete_button')}` +
                    '</div>';
            }

            newRow += '</td>';
        }

        newRow += '</tr>';

        $('#slItems tbody').append(newRow);

        bindFileUploadControls();

        if (reInitSelectForIconsRequired)
            select.init({
                selector: '.select-icons:not(#iconControlTemplate .select-icons)',
                isIconSelect: true
            });

        // Auto scroll to bottom of table and focus first cell
        const $scrollBody = $('#slItems');
        $scrollBody.scrollTop($scrollBody.get(0).scrollHeight);
        setTimeout(function() {
            $('#slItems tbody:last-child .dataCol.dataCol0 input').focus();
        }, 500);
    }

    function bindAddRow() {
        // Adds a new row
        $('.addValue').off().on('click', function(event) {
            event.preventDefault();
            addNewRow();
        });
    }

    function bindFileUploadControls() {

        ($('.dataCol input[name=imageFile]') as any).fileupload({
            dataType: 'json',
            dropZone: $('#imageUploadTemplate'),
            change: function(event: any, data: any) {
                const f = data.files[0];

                if (!f)
                    return false;

                const isValidExt = appn.utils.isValidFileExtension(['png', 'jpg', 'jpeg'], f.name);
                const isValidSize = appn.utils.IsValidFileSize(2000, f);

                if (!isValidExt || !isValidSize)
                    // Clear out the bad file
                    $(this).closest('.fileinput').find('.btn.btn-remove').click();

                return isValidExt && isValidSize;
            },
            done: function(event: any, data: any) {
                if (data.result.error) {
                    appn.fileUploadUtils.fileUploadFailed(data.result.error);
                    return false;
                }

                // Update imageFileLocation input with url from the server
                const $fileField = $('#' + event.target.id);
                const imageUrlAbsolute = appn.urls.root + data.result;
                $fileField.closest('.dataCol').find('.imageFileLocation').val(imageUrlAbsolute);

                appn.toast.notify(toast.Type.success, T(`Image uploaded successfully. Don't forget to save your changes!`));

                return true;
            },
            error: function(response: any) {
                appn.fileUploadUtils.fileUploadFailed();
            }
        });

        $('.btn.btn-remove').off().on('click', function(e) {
            e.preventDefault();

            // Get the image input element
            const $imageFileLocation = $(this).closest('.dataCol').find('.imageFileLocation');
            const _that = $(this);
            const afterDeleteCallback = function() {
                // Clear image from value input so its saved this way
                $imageFileLocation.val(appn.emptyString);

                // Must save the datasource here otherwise the image is deleted on the server but the value for this inpout still has the image url if the user forgets to save.
                // saveAndSubmitDataSource();

                const imageToReset = _that.closest('.dataCol').find('.fileinput .fileinput-new.thumbnail img');
                imageToReset.prop('src', _initArgs.placeholderImageUrl);

                _that.hide();
            };

            // Tell server to delete this image
            deleteImageFromServer($imageFileLocation.val() as string, afterDeleteCallback);
        });

        $('.select-icons').off().on('change', function(e) {
            e.preventDefault();

            const $iconDisplayImage = $(this).closest('.dataCol').find('img');

            // If nothing is selected then show place holder
            if (!$(this).val()) {
                $iconDisplayImage.prop('src', _initArgs.placeholderImageUrl);
                return;
            }

            appn.ajax.post({
                url: _initArgs.dataSourcesGetIconUrl,
                dataType: 'json',
                data: {
                    iconName: $(this).val()
                },
                done: function(iconUrlFromServer: string) {
                    $iconDisplayImage.prop('src', iconUrlFromServer);
                },
                fail: function() {
                    appn.toast.notify(toast.Type.error, T('Icon not found!'));
                }
            });
        });
    }

    function bindDisplayConditions($div: JQuery<HTMLElement>) {

        appn.minicolors.init(undefined, _initArgs.canSave, $div.find('.colorPicker'));

        const $decorHidden = $div.find('input.decorHidden');
        const $boldBtn = $div.find('.displayBold');
        const $italicBtn = $div.find('.displayItalic');
        if ($decorHidden.val() === 'Bold')
            $boldBtn.addClass('active');
        else if ($decorHidden.val() === 'Italic')
            $italicBtn.addClass('active');
        else {
            $boldBtn.removeClass('active');
            $italicBtn.removeClass('active');
        }
        $boldBtn.off().on('click', function(event) {
            if ($decorHidden.val() === 'Bold') {
                $boldBtn.removeClass('active');
                $decorHidden.val('Normal');
            } else {
                $boldBtn.addClass('active');
                $italicBtn.removeClass('active');
                $decorHidden.val('Bold');
            }
        });
        $italicBtn.off().on('click', function(event) {
            if ($decorHidden.val() === 'Italic') {
                $italicBtn.removeClass('active');
                $decorHidden.val('Normal');
            } else {
                $italicBtn.addClass('active');
                $boldBtn.removeClass('active');
                $decorHidden.val('Italic');
            }
        });

        const $delBtn = $div.find('.delete_button');
        $delBtn.off().on('click', function() {
            const $ruleDiv = $(this).closest('div.displayRule').remove();
        });
    }

    function applyFiltersAndOptions(clearFilters: boolean) {
        const dataSourceId = _initArgs.dataSourceId;

        // Get all the filters and append them to the form
        if (clearFilters === false)
            for (let i = 0; i < _filterIdsInUse.length; i++) {

                $('<input />').attr('type', 'hidden')
                    .attr('name', 'FilterHeader' + _filterIdsInUse[i])
                    .attr('value', $('#filterHeader' + _filterIdsInUse[i]).val() as string)
                    .appendTo('#appnForm');

                $('<input />').attr('type', 'hidden')
                    .attr('name', 'FilterFunction' + _filterIdsInUse[i])
                    .attr('value', $('#filterFunction' + _filterIdsInUse[i]).val() as string)
                    .appendTo('#appnForm');

                $('<input />').attr('type', 'hidden')
                    .attr('name', 'FilterBy' + _filterIdsInUse[i])
                    .attr('value', $('#filterBy' + _filterIdsInUse[i]).val() as string)
                    .appendTo('#appnForm');
            }

        // Get the formula and append it to the form
        $('<input />').attr('type', 'hidden')
            .attr('name', 'FormulaFilter')
            .attr('value', $('#Formula').val() as string)
            .appendTo('#appnForm');

        // Get the sort order and column to sort by
        $('<input />').attr('type', 'hidden')
            .attr('name', 'SortOrder')
            .attr('value', $('#SortTypeList').val() as string)
            .appendTo('#appnForm');

        $('<input />').attr('type', 'hidden')
            .attr('name', 'ByColumn')
            .attr('value', $('#SortTypeColumnList').val() as string)
            .appendTo('#appnForm');

        // Post the result
        $('<input />').attr('type', 'hidden')
            .attr('name', 'submitType')
            .attr('value', 'Filter')
            .appendTo('#appnForm');

        appn.dialog.showLoading();
        $('#appnForm').submit();
    }

    // if the first column is datatime, we have to add the date time picker on init
    function addDateTimePickerOnInit(id: string = '1') {
        const $filterHeader = $('#filterHeader' + id);
        const header = $filterHeader.find(':selected').val() as string;
        const headerType: string = _headerTypes[header];
        if (headerType === 'DateTime') {
            if (!$('#filterBy' + id).parent().hasClass('datetimepicker')) {
                const val = $('#filterBy' + id).val();
                $('#filterBy' + id).parent().each(function () {
                    $(`<div class="input-group date datetimepicker">
                                <input class="form-control" id="filterBy${id}" name="filterBy${id}" type="text" value="${val}">
                                <div class="input-group-append input-group-addon">
                                    <button class="input-group-text btn btn-secondary" type="button"><i class="fa fa-calendar fa-xs"></i></button>
                                </div>
                               </div>`)
                        .insertBefore(this);
                }).remove();
            }

            // Add the function to display the popup calendar.
            // The calendar only displays on the second click,
            // so simulate one click to make it instant for users.
            $('#filterBy' + id).on('click', function() {
                appn.ui.dateTimePicker(($(this) as any), undefined, 'YYYY-MM-DD HH:mm:ss');
            }).trigger('click');           
        }
    }

    interface Header {
        name: string;
        refId: string;
        dataType: string;
    }

    interface ReferringDatasourceColumn {
        refId: string;
        columns: Array<string>;
    }

    interface AppliedFilter {
        headerName: string;
        filterType: string;
        dataValue: string;
    }
}
